import { useEffect, useState } from "react";
import DataTable from "../../components/DataTable";
import StatusBadge from "../../components/StatusBadge";
import { api } from "../../lib/api";
import { AdminHeader } from "./AdminShell";

type Submission = Record<string, any>;

export default function PaymentProofs() {
  const [rows, setRows] = useState<Submission[]>([]);
  async function load() { setRows(await api<Submission[]>("/api/admin/payment-submissions")); }
  useEffect(() => { load().catch(() => setRows([])); }, []);
  async function review(id: number, status: "paid" | "rejected") {
    const admin_note = prompt("Admin note") || "";
    await api(`/api/admin/payment-submissions/${id}/review`, { method: "PUT", body: JSON.stringify({ status, admin_note }) });
    await load();
  }
  return (
    <div>
      <AdminHeader title="Payment Reviews" description="Review submitted TXIDs and payment notes. Confirming a payment marks the order as paid; rejecting sends it back to pending payment." />
      <DataTable rows={rows} columns={[
        { key: "order_no", label: "Order" },
        { key: "customer_name", label: "Customer" },
        { key: "amount", label: "Amount" },
        { key: "payment_method_name", label: "Method" },
        { key: "txid", label: "TXID" },
        { key: "note", label: "Note" },
        { key: "status", label: "Status", render: (row) => <StatusBadge status={String(row.status)} /> },
        { key: "id", label: "Actions", render: (row) => <div className="flex gap-2"><button className="btn-secondary px-4 py-2 text-emerald-700" onClick={() => review(Number(row.id), "paid")}>Confirm</button><button className="btn-secondary px-4 py-2 text-red-600" onClick={() => review(Number(row.id), "rejected")}>Reject</button></div> }
      ]} />
    </div>
  );
}
